import { Navigate, Outlet } from "react-router-dom";

const AuthenticatedRoutes = ({ isAuth, isAdmin }) => {
    if (!isAuth) {
        return <Navigate to="/login" />;
    }
    if (isAdmin) {
        return <Navigate to="/admin/orders" />;
    }

    return <Outlet />;
};

export default AuthenticatedRoutes;
